module.exports = __webpack_public_path__ + "ae.no2.a4157138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ae.no2.jpg
// module id = GSEg
// module chunks = 0